"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var uniqueId_1 = __importDefault(require("../../util/uniqueId"));
var react_1 = require("react");
var ClotheColor_1 = __importDefault(require("./ClotheColor"));
function ShirtScoopNeck2() {
    var path1 = react_1.useMemo(function () { return uniqueId_1.default('react-path-'); }, []);
    var mask1 = react_1.useMemo(function () { return uniqueId_1.default('react-mask-'); }, []);
    return (jsx_runtime_1.jsxs("g", __assign({ transform: 'translate(0.000000, 170.000000)' }, { children: [jsx_runtime_1.jsx("defs", { children: jsx_runtime_1.jsx("path", { id: path1, d: 'M181.544255,32.3304167 C210.784209,41.4878872 232,68.7921987 232,101.051724 L232,110 L32,110 L32,101.051724 C32,68.3969699 53.7388273,40.8195914 83.5340368,32.0020332 C83.182234,33.4201865 83,34.8712315 83,36.3476251 C83,52.6289957 105.161905,65.8276544 132.5,65.8276544 C159.838095,65.8276544 182,52.6289957 182,36.3476251 C182,34.9849859 181.844766,33.6439396 181.544255,32.3304167 Z' }, void 0) }, void 0),
            jsx_runtime_1.jsx("mask", __assign({ id: mask1, fill: 'white' }, { children: jsx_runtime_1.jsx("use", { xlinkHref: '#' + path1 }, void 0) }), void 0),
            jsx_runtime_1.jsx("use", { fill: '#E6E6E6', fillRule: 'evenodd', xlinkHref: '#' + path1 }, void 0),
            jsx_runtime_1.jsx(ClotheColor_1.default, { maskID: mask1 }, void 0)] }), void 0));
}
exports.default = ShirtScoopNeck2;
